import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Form, Button, Typography, Input, message } from "antd";
import { connect } from "react-redux";

import { LOCAL_LANG, EMAIL_ACTION_TYPE } from "../common/const";
import {
  PostEmailCheck,
  PostEmailSend,
  PostEmailVerify,
  PostEmailRegisterSend,
} from "../config/request";
import {
  OpenBrowserUrl,
  getDeviceType,
  getNextPathByRegisterStatus,
  getRedirectUrl,
  googleStatis,
} from "../common/globalFun";
import { useIntl } from "react-intl";

import HeaderLogo from "../components/HeaderLogo";
import ErrorHintText from "../components/ErrorHintText";
import * as GA4Tracker from "../common/GA4Tracker";

import "./css/style.css";

const { Title } = Typography;
const ResendTime = 60;

const HTML_LANG = {
  "zh-TW": "zh",
  "en-US": "en",
  "ja-JP": "ja",
};
const IntervalCount = ({ sendEmail }) => {
  const intl = useIntl();
  const [resendNum, setResendNum] = useState(1);
  const [resendCodeSecond, setResendCodeSecond] = useState(ResendTime);
  const resendCodeSecondRef = useRef(ResendTime);
  const checkStateTimeRef = useRef();

  useEffect(() => {
    resendCodeSecondRef.current = resendCodeSecond;
    checkStateTimeRef.current = new Date().getTime();
  });

  useEffect(() => {
    let resendTimer = null;
    if (resendCodeSecond === ResendTime) {
      resendTimer = setInterval(() => {
        if (!resendCodeSecondRef.current) {
          clearInterval(resendTimer);
          return;
        }
        setResendCodeSecond((resendCodeSecond) => resendCodeSecond - 1);
      }, 1000);
    }

    return () => clearInterval(resendTimer);
  }, [resendNum]);

  const cb = () => {
    setResendNum(resendNum + 1);
    setResendCodeSecond(ResendTime);
  };

  const onClick = () => {
    sendEmail(cb);
  };

  return (
    <>
      {!!resendCodeSecond ? (
        <span className="count-down-num">{resendCodeSecond} S</span>
      ) : (
        <Button
          type="link"
          block
          size="large"
          onClick={onClick}
          className="resend-button"
        >
          {intl.formatMessage({ id: "resent.email" })}
        </Button>
      )}
    </>
  );
};

const VerifyPage = (props) => {
  const { history } = props;
  const intl = useIntl();
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const data = props.location.data;

  const [loading, setLoading] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  // 验证码是否有效的变量
  const [codeValid, setCodeValid] = useState(false);

  const [codeStatus, setCodeStatus] = useState({
    validateStatus: "error",
    errorMsg: "",
  });

  const submit = (values) => {
    const { code } = values;
    if (props.emailActionType === EMAIL_ACTION_TYPE.REGISTER) {
      checkRegisterCode(code);
    } else {
      checkCode(code);
    }
  };

  const sendEmail = (cb) => {
    const { email } = props;
    if (!email || sendLoading) {
      return;
    }

    setSendLoading(true);
    let method = PostEmailSend;
    if (props.emailActionType === EMAIL_ACTION_TYPE.REGISTER) {
      method = PostEmailRegisterSend;
    }

    method({
      account: email,
      device_type: getDeviceType(),
      lang: LOCAL_LANG[intl.locale],
      check_type: props.emailActionType,
    })
      .then(() => {
        cb();
        props.setGlobalEmail(email);

        messageApi.open({
          type: "success",
          content: intl.formatMessage({ id: "verify.code.send.success" }),
          className: "custom-ant-alert",
        });
      })
      .catch(() => {
        messageApi.open({
          type: "error",
          content: intl.formatMessage({ id: "verify.code.send.error" }),
          className: "custom-ant-alert",
        });
      })
      .finally(() => {
        setSendLoading(false);
      });
  };
  const checkRegisterCode = (code) => {
    // 埋点注册验证码验证
    googleStatis("Signup", "Signup_enter code");
    setLoading(true);
    PostEmailVerify({
      email: props.email,
      verify_code: code,
      invite_code: props.inviteCode,
      lang: HTML_LANG[intl.locale],
      code: window.sessionStorage.getItem("recommend") || "",
    })
      .then((res) => {
        const { certificate, exist_invite, login_key } = res.data;
        props.setGlobalLoginKey(login_key);
        // 如果是邀请注册 去到邀请列表
        if (exist_invite) {
          history.replace("/invite_list");
        } else {
          const redirectUrl = getRedirectUrl();
          // 如果是普通注册
          if (props.inviteCode) {
            window.location.href = `${redirectUrl}`;
          } else {
            window.location.href = `${redirectUrl}?isRegister=true`;
          }
        }
      })
      .catch(({ code, msg }) => {
        setCodeStatus({
          validateStatus: "error",
          errorMsg: <ErrorHintText text={msg} />,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const checkCode = (code) => {
    // 普通验证码验证
    GA4Tracker.customEvent("verify", "other");
    setLoading(true);
    PostEmailCheck({
      account: props.email,
      code: code,
    })
      .then((rsp) => {
        const { status, checkKey } = rsp;
        if (checkKey) {
          props.setGlobalEmailCheckKey(checkKey);
        }
        if (props.emailActionType === EMAIL_ACTION_TYPE.REGISTER) {
          const nextPath = getNextPathByRegisterStatus(status);
          history.replace({ pathname: nextPath, data: { status: status } });
        } else {
          history.replace({ pathname: "/set_pwd" });
        }
      })
      .catch(({ code, msg }) => {
        setCodeStatus({
          validateStatus: "error",
          errorMsg: <ErrorHintText text={msg} />,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const codeOnChange = (e) => {
    const code = e.target.value;
    if (!code || code.length !== 6) {
      setCodeValid(false);
      return;
    }
    if (!/^\d{6}$/.test(code)) {
      setCodeValid(false);
      return;
    }

    setCodeValid(true);
  };

  useEffect(() => {
    if (data && data.showSentAlert) {
      messageApi.open({
        type: "success",
        content: intl.formatMessage({ id: "verify.code.send.success" }),
        className: "custom-ant-alert",
      });
    }
  }, [data]);

  return (
    <>
      {contextHolder}
      <HeaderLogo />
      <Row justify={"start"} align="start" className={`main-content`}>
        <Col span={24}>
          <div className={`mb-28 page-title`}>
            <Title level={2} className="mt-10">
              {intl.formatMessage({ id: "verify.title" })}
            </Title>
            <p className="title-exp">
              {intl.formatMessage(
                { id: "send.email.to" },
                { email: props.email }
              )}
              <br />
              {intl.formatMessage({ id: "enter.verify.code" })}
            </p>
          </div>
          <section className="content-center">
            <Form form={form} onFinish={submit}>
              <Form.Item
                name="code"
                className="account-input"
                onChange={codeOnChange}
                validateStatus={codeStatus.validateStatus}
                help={codeStatus.errorMsg}
              >
                <Input
                  autoComplete="off"
                  placeholder={intl.formatMessage({
                    id: "verify.code.placeholder",
                  })}
                  size="large"
                  disabled={loading}
                />
              </Form.Item>
              {<IntervalCount sendEmail={sendEmail} />}
              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  className={`submit-button`}
                  block
                  size="large"
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  g-action={123}
                  g-category="login"
                  disabled={!codeValid || loading}
                >
                  {intl.formatMessage({
                    id: "btn.complete",
                  })}
                </Button>
              </Form.Item>
            </Form>

            <p className="mt-32 contact-us-box">
              {intl.formatMessage({ id: "find.code.tip" })}
              <br />
              {intl.formatMessage({ id: "find.code.tip2" })}
              <Button
                type="link"
                size="small"
                onClick={() => {
                  OpenBrowserUrl("https://twitter.com/FeloApp", "_self", false);
                }}
                className="contact-us"
              >
                {intl.formatMessage({ id: "contact.us.lower" })}
              </Button>
            </p>
          </section>
        </Col>
      </Row>
    </>
  );
};

const stateProps = (state) => {
  return {
    token: state.token,
    email: state.email,
    redirectUri: decodeURIComponent(state.redirectUri),
    emailActionType: state.emailActionType,
    inviteCode: state.inviteCode,
  };
};

const dispatchProps = (dispatch) => ({
  setGlobalLoginKey: (key) => {
    dispatch({
      type: "setLoginKey",
      value: key,
    });
  },
  setGlobalToken: (token) => {
    dispatch({
      type: "setToken",
      value: token,
    });
  },
  setGlobalEmail: (email) => {
    dispatch({
      type: "setEmail",
      value: email,
    });
  },
  setGlobalEmailCheckKey: (key) => {
    dispatch({
      type: "setEmailCheckKey",
      value: key,
    });
  },
});

export default connect(stateProps, dispatchProps)(VerifyPage);
